import styled from 'styled-components'

import { Text as TextUI } from '@interco/inter-ui/components/Text'
import * as GlobalStyles from '@/styles/styles'

export const Container = styled.div`
  width: 100%;
`
export const Space = styled(GlobalStyles.DefaultSpace)``

export const Text = styled(TextUI)``

export const ContainerAccordion = styled.div`
  > div {
    border-bottom: 1px solid var(--gray200);
  }
  > div:last-child {
    border-bottom: 0;
  }
`

export const AccordionContentContainer = styled.div`
  padding-top: 28px;

  a {
    color: var(--primary500);
    text-decoration: none;
    font-weight: bold;
  }
`
